import React from 'react'

export const typedMatches = (typed, expected) => typed.trim() === `${expected}`.trim()

const TypedCheck = ({ id, label, value, onChange, disabled, className = 'flex flex-col gap-1' }) => (
  <div className={className}>
    <label htmlFor={id} className="text-sm text-text-primary">
      {label}
    </label>
    <input
      id={id}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      disabled={disabled}
      autoComplete="off"
      className="w-full px-3 py-2 rounded-lg border border-divider bg-paper text-text-primary text-md"
    />
  </div>
)

export default TypedCheck
